import { message as messageAD } from 'antd';
import type { ReactNode } from 'react';
import { MessageContent } from './message-content';
import { MessageIcon, type MessageType } from './message-icon';

type Options = {
  duration?: number;
  onClose?: () => void;
  textAlign?: 'center' | 'left' | 'right';
};

const openMessage = async (type: MessageType, content: ReactNode, { duration, onClose, textAlign }: Options = {}) =>
  Promise.resolve(
    messageAD.open({
      content: <MessageContent label={content} textAlign={textAlign} />,
      duration,
      icon: <MessageIcon type={type} />,
      onClose,
      type,
    }),
  ).catch((error: unknown) => {
    console.error(error);
  });

const message = {
  error(content: ReactNode, options?: Options) {
    void openMessage('error', content, options);
  },
  info(content: ReactNode, options?: Options) {
    void openMessage('info', content, options);
  },
  loading(content: ReactNode, options?: Options) {
    void openMessage('loading', content, options);
  },
  success(content: ReactNode, options?: Options) {
    void openMessage('success', content, options);
  },
  warn(content: ReactNode, options?: Options) {
    void openMessage('warning', content, options);
  },
};

export default message;
